// Official Melto Studios brand mark — solid cyan circle, centered bold M.
// Completely flat: no gradients, no shadows, no 3D. Geometric and legible at 16px.
export const MELTO_CYAN = "#06b6d4";

export const MeltoLogo = ({ size = 32, className = "", testid }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    className={className}
    role="img"
    aria-label="Melto Studios"
    data-testid={testid}
  >
    <circle cx="32" cy="32" r="32" fill={MELTO_CYAN} />
    <path
      d="M16 46 L16 18 L23 18 L32 34 L41 18 L48 18 L48 46 L41 46 L41 27 L32 42 L23 27 L23 46 Z"
      fill="#ffffff"
    />
  </svg>
);
